module.exports = __webpack_public_path__ + "img/lock_thumb.315aa533.jpg";